module.exports = __webpack_public_path__ + "static/media/logowhite.10041164.svg";